module.exports = __webpack_public_path__ + "img/tienda-angular.a255b31b.png";